;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type { User } from '@workspace/ui/types';
import fetchAPI from '@/lib/fetch-api';

export const getEmployerByOrganisationId = async (organisationId: number): Promise<User[]> => {
  const response = await fetchAPI<User[]>(
    `${process.env.NEXT_PUBLIC_SSO_API_URL}/get-employers-from-organisation?organisation_id=${organisationId}`,
    {
      method: 'GET',
    }
  );

  if (!response.success && (!response.status || ![200, 201].includes(response.status))) {
    throw new Error(
      response.error || response.message || 'Failed to fetch employers from organisation'
    );
  }

  if (!response.data) {
    throw new Error('Invalid response format: missing data');
  }

  return response.data;
};
